export const URL_PREFIX_CHECKOUT_SOURCE = 'url-prefix';

export type UrlPrefixCheckoutSource = typeof URL_PREFIX_CHECKOUT_SOURCE;

const MAX_CONTINUE_PATH_LENGTH = 4096;

export function normalizeUrlPrefixCheckoutSource(value: unknown): UrlPrefixCheckoutSource | null {
  return value === URL_PREFIX_CHECKOUT_SOURCE ? URL_PREFIX_CHECKOUT_SOURCE : null;
}

export function normalizeUrlPrefixContinuePath(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  if (!/^\/https?:\//i.test(value) || value.startsWith('//') || value.length > MAX_CONTINUE_PATH_LENGTH) {
    return null;
  }
  return value;
}

export function appendUrlPrefixCheckoutContinuation(
  baseUrl: string,
  source: unknown,
  continuePath: unknown
): string {
  const normalizedSource = normalizeUrlPrefixCheckoutSource(source);
  const normalizedPath = normalizeUrlPrefixContinuePath(continuePath);
  if (!normalizedSource || !normalizedPath) {
    return baseUrl;
  }

  const hashIndex = baseUrl.indexOf('#');
  const beforeHash = hashIndex === -1 ? baseUrl : baseUrl.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : baseUrl.slice(hashIndex);
  const joiner = beforeHash.includes('?') ? '&' : '?';
  return `${beforeHash}${joiner}source=${URL_PREFIX_CHECKOUT_SOURCE}&continue=${encodeURIComponent(normalizedPath)}${hash}`;
}
